export enum Feature {
  MailroomAddress = 'mailroom_address',
}
